import { render, staticRenderFns } from "./acessoRapido.vue?vue&type=template&id=256afc1a&scoped=true&"
import script from "./acessoRapido.vue?vue&type=script&lang=js&"
export * from "./acessoRapido.vue?vue&type=script&lang=js&"
import style0 from "./acessoRapido.vue?vue&type=style&index=0&id=256afc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256afc1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
